"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var paperArea_1 = require("../diagram/paperArea");
var async_1 = require("../viewUtils/async");
var events_1 = require("../viewUtils/events");
var keyedObserver_1 = require("../viewUtils/keyedObserver");
var workspaceMarkup_1 = require("../workspace/workspaceMarkup");
var authoringState_1 = require("./authoringState");
/**
 * Component to simplify tracking changes in validation messages (property and link type labels).
 */
var AuthoredEntity = /** @class */ (function (_super) {
    tslib_1.__extends(AuthoredEntity, _super);
    function AuthoredEntity(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.listener = new events_1.EventObserver();
        _this.queryCancellation = new async_1.Cancellation();
        _this.onEdit = function () {
            var editor = _this.context.ontodiaWorkspace.editor;
            var elementId = _this.props.templateProps.elementId;
            var element = editor.model.getElement(elementId);
            editor.showEditEntityForm(element);
        };
        _this.onDelete = function () {
            var editor = _this.context.ontodiaWorkspace.editor;
            var data = _this.props.templateProps.data;
            editor.deleteEntity(data.id);
        };
        _this.state = {};
        return _this;
    }
    AuthoredEntity.prototype.componentDidMount = function () {
        var _this = this;
        var editor = this.context.ontodiaWorkspace.editor;
        var templateProps = this.props.templateProps;
        var iri = templateProps.data.id;
        this.listener.listen(editor.events, 'changeAuthoringState', function (_a) {
            var previous = _a.previous;
            var current = editor.authoringState;
            if (current.index.elements.get(iri) !== previous.index.elements.get(iri)) {
                _this.queryAllowedActions();
            }
        });
        this.linkTypesObserver = keyedObserver_1.observeLinkTypes(editor.model, 'changeLabel', function () { return _this.forceUpdate(); });
        this.propertiesObserver = keyedObserver_1.observeProperties(editor.model, 'changeLabel', function () { return _this.forceUpdate(); });
        this.observeTypes();
        this.queryAllowedActions();
    };
    AuthoredEntity.prototype.componentDidUpdate = function (prevProps) {
        this.observeTypes();
        var shouldUpdateAllowedActions = !(this.props.templateProps.data === prevProps.templateProps.data &&
            this.props.templateProps.isExpanded === prevProps.templateProps.isExpanded);
        if (shouldUpdateAllowedActions) {
            this.queryAllowedActions();
        }
    };
    AuthoredEntity.prototype.observeTypes = function () {
        var editor = this.context.ontodiaWorkspace.editor;
        var iri = this.props.templateProps.data.id;
        var validation = editor.validationState.elements.get(iri);
        if (validation) {
            this.linkTypesObserver.observe(validation.errors.map(function (error) { return error.linkType; }).filter(function (type) { return type; }));
            this.propertiesObserver.observe(validation.errors.map(function (error) { return error.propertyType; }).filter(function (type) { return type; }));
        }
        else {
            this.linkTypesObserver.observe([]);
            this.propertiesObserver.observe([]);
        }
    };
    AuthoredEntity.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
        this.linkTypesObserver.stopListening();
        this.propertiesObserver.stopListening();
        this.queryCancellation.abort();
    };
    AuthoredEntity.prototype.queryAllowedActions = function () {
        var _a = this.props.templateProps, isExpanded = _a.isExpanded, elementId = _a.elementId, data = _a.data;
        // only fetch whether it's allowed to edit when expanded
        if (!isExpanded) {
            return;
        }
        this.queryCancellation.abort();
        this.queryCancellation = new async_1.Cancellation();
        var editor = this.context.ontodiaWorkspace.editor;
        if (!editor.metadataApi || isDeletedElement(editor.authoringState, data.id)) {
            this.setState({ canEdit: false, canDelete: false });
        }
        else {
            this.queryCanEdit(data);
            this.queryCanDelete(data);
        }
    };
    AuthoredEntity.prototype.queryCanEdit = function (data) {
        var _this = this;
        var editor = this.context.ontodiaWorkspace.editor;
        var elementId = this.props.templateProps.elementId;
        var signal = this.queryCancellation.signal;
        this.setState({ canEdit: undefined });
        editor.metadataApi.canEditElement(data, signal).then(function (canEdit) {
            if (signal.aborted) {
                return;
            }
            _this.setState({ canEdit: canEdit });
        });
    };
    AuthoredEntity.prototype.queryCanDelete = function (data) {
        var _this = this;
        var editor = this.context.ontodiaWorkspace.editor;
        var elementId = this.props.templateProps.elementId;
        var signal = this.queryCancellation.signal;
        this.setState({ canDelete: undefined });
        editor.metadataApi.canDeleteElement(data, signal).then(function (canDelete) {
            if (signal.aborted) {
                return;
            }
            _this.setState({ canDelete: canDelete });
        });
    };
    AuthoredEntity.prototype.render = function () {
        var renderTemplate = this.props.children;
        var view = this.context.ontodiaPaperArea.view;
        var editor = this.context.ontodiaWorkspace.editor;
        var _a = this.state, canEdit = _a.canEdit, canDelete = _a.canDelete;
        return renderTemplate({
            editor: editor, view: view, canEdit: canEdit, canDelete: canDelete,
            onEdit: this.onEdit,
            onDelete: this.onDelete,
        });
    };
    AuthoredEntity.contextTypes = tslib_1.__assign({}, paperArea_1.PaperAreaContextTypes, workspaceMarkup_1.WorkspaceContextTypes);
    return AuthoredEntity;
}(React.Component));
exports.AuthoredEntity = AuthoredEntity;
function isDeletedElement(state, target) {
    var event = state.index.elements.get(target);
    return event && event.type === authoringState_1.AuthoringKind.DeleteElement;
}
